import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import moment from 'moment';
import PageHeader from '../components/PageHeader';
import { namespace } from '../../../config.json';

import compareDates from '../utils/compareDates';
import getDateFormat from '../utils/getDateFormat';

import LoadingSpinner from '../components/LoadingSpinner';
import metricsTools from '../utils/metricsTools';

// Styling
import brandingStyles from '../branding/brandingStyles';
const config = require('../branding/branding.json');
if (config.darkUICharts) {
    require('../components/charts/DarkCharts.css');
} else {
    require('../components/charts/LightCharts.css');
}

// Requests
import BucketsAPI from '../utils/BucketsAPI';
import MetricsAPI from '../utils/MetricsAPI';

// External
import Reactable from 'reactable';
import { DebounceInput } from 'react-debounce-input';

// Charts
import StorageHistoryChart from '../components/charts/StorageHistoryChartComponent';
import StoragePieChart from '../components/charts/BucketStoragePieChartComponent';

// Setting reactable values instead of regular table
const Table = Reactable.Table;
const Thead = Reactable.Thead;
const Th = Reactable.Th;
const Tr = Reactable.Tr;
const Td = Reactable.Td;

// BucketsComponent Component
class BucketsComponent extends Component {

    constructor() {
        super();
        this.state = {
            buckets: [],
            history: [],
            historyLoaded: false,
            pageBuckets: [],
            dataLoaded: false,
            metricsError: false,
            historyError: false,
            currentPage: 1,
            itemsPerPage: 10,
            filterText: '',
            prevDisabled: false,
            nextDisabled: false,
        };
        this.refresh = this.refresh.bind(this);
        this.refreshHistory = this.refreshHistory.bind(this);
        this.mergeUtapiDataInState = this.mergeUtapiDataInState.bind(this);
        this.fillPageBuckets = this.fillPageBuckets.bind(this);
        this.handleNextPage = this.handleNextPage.bind(this);
        this.handlePreviousPage = this.handlePreviousPage.bind(this);
        this.handleFilterChange = this.handleFilterChange.bind(this);
        this.getBucketRow = this.getBucketRow.bind(this);
        this.mounted = false;
        this.metrics = new MetricsAPI();
    }

    componentDidMount() {
        this.mounted = true;
        this.refresh();
    }

    componentWillUnmount() {
        this.mounted = false;
    }

    refresh() {
        BucketsAPI.getBuckets().then(res => {
            if (this.mounted) {
                this.setState({
                    buckets: res.buckets,
                    dataLoaded: true,
                },
                () => {
                    this.fillPageBuckets();
                    this.refreshHistory();
                }
                );
            }
        });
    }

    refreshHistory() {
        const startDate = moment().subtract(6, 'days');
        const endDate = moment();

        this.metrics.getMultipleBucketsHistory(
          'days',
          metricsTools.momentToStart(startDate),
          metricsTools.momentToEnd(endDate)
        ).then(res => {
            if (this.mounted) {
                this.setState({ history: res.metrics, historyLoaded: true });
            }
        })
        .catch(() => {
            if (this.mounted) {
                this.setState({
                    history: [[]],
                    historyLoaded: true,
                    historyError: true,
                });
            }
        });
    }

    refreshUtapiData() {
        const startDate = moment().subtract(6, 'days');
        const endDate = moment();

        const idArray =
        this.state.pageBuckets.map(item => item.Name);
        if (idArray.length) {
            this.metrics.getMultipleBucketsMetrics(
              idArray,
              metricsTools.momentToStart(startDate),
              metricsTools.momentToEnd(endDate)
            )
            .then(res => {
                this.mergeUtapiDataInState(res.metrics);
            })
            .catch(res => {
                if (res.status === 401 || res.status === 403) {
                    window.location.href =
                        `${namespace}/login/error/${res.status}`;
                }
                if (this.mounted) {
                    this.setState({
                        metricsError: true,
                    });
                }
            });
        }
    }

    mergeUtapiDataInState(data) {
        // Deep cloning existing buckets array
        const current = JSON.parse(JSON.stringify(this.state.pageBuckets));

        if (current.length === data.length) {
            for (let i = 0; i < current.length; i++) {
                if (current[i].Name === data[i].bucketName) {
                    current[i].storageUtilized = data[i].storageUtilized;
                    current[i].incomingBytes = data[i].incomingBytes;
                    current[i].outgoingBytes = data[i].outgoingBytes;
                }
            }
        }
        if (this.mounted) {
            this.setState({ pageBuckets: current });
        }
    }


    getBucketRow(bucket) {
        return (
          <Tr
            key={bucket.Name}
            className="account-row"
            style={brandingStyles.fontColor}
          >
              <Td
                column="Name"
                data={bucket.Name}
                className="padding-l-25"
                style={Object.assign(
                    {
                        fontWeight: 'bold',
                        fontSize: '16px',
                    },
                    brandingStyles.fontColor
              )}>
                  {bucket.Name}
              </Td>
              <Td
                column="storageUtilized"
                value={bucket.storageUtilized}
              >
                {
                    !this.state.metricsError &&
                  (bucket.storageUtilized !== undefined ?
                  metricsTools.bytesToSize(bucket.storageUtilized) :
                  <i className="fa fa-refresh fa-spin"/>) || '-'
                }
              </Td>
              <Td column="UsedBandwidth">
                {
                    !this.state.metricsError &&
                  (bucket.incomingBytes !== undefined ?
                  <span>
                    <OverlayTrigger
                      trigger={['hover', 'focus']}
                      placement="top"
                      overlay={
                        <Tooltip id="incomingDataTooltip">
                          Incoming data
                        </Tooltip>
                      }>
                        <span>
                            <i
                              style={brandingStyles.mainColor}
                              className="fa fa-arrow-circle-up"
                            />
                            &nbsp;
                            {metricsTools.bytesToSize(bucket.incomingBytes)}
                        </span>
                    </OverlayTrigger>
                    &nbsp;
                    <OverlayTrigger
                      trigger={['hover', 'focus']}
                      placement="top"
                      overlay={
                        <Tooltip id="outgoingDataTooltip">
                          Outgoing data
                        </Tooltip>
                      }>
                        <span>
                            <i
                              style={brandingStyles.mainColor}
                              className="fa fa-arrow-circle-down"
                            />
                            &nbsp;
                            {metricsTools.bytesToSize(bucket.outgoingBytes)}
                        </span>
                    </OverlayTrigger>
                  </span> :
                  <i className="fa fa-refresh fa-spin"/>)
                  || '-'
                }
              </Td>
              <Td column="CreationDate">
                  {getDateFormat(new Date(bucket.CreationDate))}
              </Td>
              <Td column="Actions">
                <Link to={`/users/buckets/${bucket.Name}`}>
                  <OverlayTrigger
                    trigger={['hover', 'focus']}
                    placement="top"
                    overlay={
                      <Tooltip id="bucketMetricsTooltip">
                        Bucket metrics
                      </Tooltip>
                    }>
                      <button
                        className="btn btn-xs"
                        style={brandingStyles.buttons.primary}
                      >
                          <i className="fa fa-pie-chart" />
                      </button>
                    </OverlayTrigger>
                </Link>
              </Td>
          </Tr>
        );
    }

    handlePreviousPage() {
        if (this.mounted) {
            this.setState(
              { currentPage: this.state.currentPage - 1 },
              () => {
                  this.fillPageBuckets();
              }
            );
        }
    }

    handleNextPage() {
        if (this.mounted) {
            this.setState(
              { currentPage: this.state.currentPage + 1 },
              () => {
                  this.fillPageBuckets();
              }
            );
        }
    }

    handleNbItemsSelect(event) {
        localStorage.setItem('scality-nbitems-buckets',
        JSON.stringify(event.target.value));
        if (this.mounted) {
            this.setState({
                itemsPerPage: event.target.value,
                currentPage: 1,
            },
              this.fillPageBuckets);
        }
    }


    fillPageBuckets() {
        const { currentPage, itemsPerPage } = this.state;
        let buckets;
        if (this.state.filterText.length) {
            buckets = this.state.buckets.filter(item =>
                (item.Name.indexOf(this.state.filterText) !== -1)
            );
        } else {
            buckets = this.state.buckets;
        }
        const indexLast = currentPage * itemsPerPage;
        const indexFirst = indexLast - itemsPerPage;
        const currentBuckets = buckets.slice(indexFirst, indexLast);
        const prevDisabled = currentPage === 1;
        const nextDisabled = indexLast >= buckets.length;
        if (this.mounted) {
            this.setState({
                pageBuckets: currentBuckets,
                prevDisabled,
                nextDisabled,
            }, () => {
                // Retrieve metrics for new paged buckets
                this.refreshUtapiData();
            });
        }
    }

    // To handle table filter change
    handleFilterChange(e) {
        if (this.mounted) {
            this.setState(
              { filterText: e.target.value },
              () => {
                  this.fillPageBuckets();
              }
            );
        }
    }

    render() {
        const pagerInstance = (
          <ul className="pager padding-l-15 padding-r-15">
            <li
              className={this.state.prevDisabled
                ? 'previous disabled' : 'previous'}
            >
              <a
                className="clickable"
                onClick={this.handlePreviousPage}
                style={brandingStyles.buttons.primary}
              >&larr;</a>
            </li>
            <li
              className={this.state.nextDisabled ? 'next disabled' : 'next'}
            >
              <a
                className="clickable"
                onClick={this.handleNextPage}
                style={brandingStyles.buttons.primary}
              >&rarr;</a>
            </li>
          </ul>
        );

        const bucketsList = this.state.pageBuckets.map(
          item => this.getBucketRow(item)
        );

        const table = <Table className="table table-striped" id="table"
          sortable={[
              'Name',
              'storageUtilized',
              {
                  column: 'CreationDate',
                  sortFunction: compareDates,
              },
          ]}
          hideFilterInput
          filterable={['Name', 'arn', 'CreationDate']}>
            <Thead>
                <Th column="Name" className="padding-l-25">
                    <strong className="name-header">Bucket name</strong>
                </Th>
                <Th column="storageUtilized">
                    <strong className="name-header">Used Storage</strong>
                </Th>
                <Th column="UsedBandwidth">
                    <strong className="name-header">Last week Bandwidth</strong>
                </Th>
                <Th column="CreationDate">
                    <strong className="name-header">Created on</strong>
                </Th>
                <Th column="Actions">
                </Th>
            </Thead>
            {bucketsList}
        </Table>;

        const storageHistoryChart = this.state.historyLoaded ?
        (<StorageHistoryChart
          data={this.state.history}
          height={300}
        />) : <LoadingSpinner />;

        const storagePieChart = this.state.historyLoaded ?
          (<StoragePieChart
            data={this.state.history[this.state.history.length - 1]}
            height={300}
            title="Buckets"
            donut={true}
            labels={false}
            legend={true}
          />) : <LoadingSpinner />;


        return (
          <div id="page-wrapper" style={brandingStyles.backgrounds.main}>
                <PageHeader facode="archive" title="Buckets"/>

                  <div className="row">
                    <div className="col-md-4">

                      <div
                        className="panel panel-default"
                        style={brandingStyles.backgrounds.panel}
                      >
                          <div className="panel-heading"
                            style={brandingStyles.backgrounds.panelHeader}
                          >
                            <i
                              className="fa fa-pie-chart"
                              style={brandingStyles.mainColor}
                            />
                            <span>&nbsp;</span>
                            Current use
                          </div>

                          <div className="panel-body padding-0">
                            {storagePieChart}
                          </div>

                    </div>


                    </div>
                    <div className="col-md-8">

                      <div
                        className="panel panel-default"
                        style={brandingStyles.backgrounds.panel}
                      >
                          <div className="panel-heading"
                            style={brandingStyles.backgrounds.panelHeader}
                          >
                            <i
                              className="fa fa-bar-chart"
                              style={brandingStyles.mainColor}
                            />
                            <span>&nbsp;</span>
                            Last week History
                          </div>

                          <div className="panel-body padding-0">
                            {storageHistoryChart}
                          </div>

                    </div>


                    </div>
                  </div>

                <div
                  className="panel panel-default"
                  style={brandingStyles.backgrounds.panel}
                >
                    <div className="panel-body padding-0">
                        <div className="input-group">
                              <div
                                className="input-group-addon"
                                style={brandingStyles.backgrounds.input}
                              >
                                <i className="fa fa-search"/>
                              </div>
                              <DebounceInput
                                className="form-control full-width"
                                debounceTimeout={300}
                                style={brandingStyles.backgrounds.input}
                                placeholder="Find buckets"
                                value={this.state.filterText}
                                onChange={this.handleFilterChange}
                              />
                              <div
                                className="input-group-addon"
                                style={brandingStyles.backgrounds.input}
                              >
                                <select
                                className="form-control pull-right
                                pagination-select"
                                style={Object.assign(
                                  {},
                                  brandingStyles.backgrounds.input,
                                  { height: 'auto' }
                                )}
                                value={this.state.itemsPerPage}
                                onChange={this.handleNbItemsSelect.bind(this)}>
                                  <option value="10">10</option>
                                  <option value="20">20</option>
                                  <option value="50">50</option>
                                </select>
                              </div>
                        </div>
                        <div className="table-responsive">
                            {this.state.dataLoaded ? table : <LoadingSpinner />}
                            {pagerInstance}
                        </div>
                    </div>
                </div>
          </div>
        );
    }
}
export default BucketsComponent;



/** WEBPACK FOOTER **
 ** ./src/pages/Buckets.js
 **/